import { Fragment, SetStateAction, Dispatch } from "react";

export default function Countries({
	countries,
	setCountry,
}: {
	countries: string[];
	setCountry?: Dispatch<SetStateAction<string>>;
}) {

	function CountryLink({ name }: { name: string; }) {

		return (setCountry ? (
			<a
				className="cursor-pointer font-bold hover:text-black hover:underline"
				onClick={() => {
					setCountry(name);
				}}>
				{name}
			</a>
		) : (
			<span className="font-bold">{name}</span>
		));
	}

	return (
		<>
			{countries.length === 1 && (
				<>
					Only found in <CountryLink name={countries[0]} />.
				</>
			)}
			{countries.length === 2 && (
				<>
					Found in <CountryLink name={countries[0]} /> and{" "}
					<CountryLink name={countries[1]} />.
				</>
			)}
			{countries.length > 2 && (
				<>
					Found in{" "}
					{countries.slice(0, countries.length - 1).map((name) => (
						<Fragment key={name}>
							<CountryLink name={name} />,{" "}
						</Fragment>
					))}{" "}
					and <CountryLink name={countries[countries.length - 1]} />.
				</>
			)}
		</>
	)
}
